import { IconButton, useTheme } from '@mui/material';
import React from 'react';
import { LuMenu as MenuIcon, LuMenu as MenuOpenIcon } from 'react-icons/lu';

export type SidebarToggleButtonProps = {
  isSidebarOpen: boolean;
  onToggle: () => void;
  className?: string;
};

/**
 * Sidebar Toggle Button Component
 * Handles the hamburger menu button with visual feedback and animations
 */
const SidebarToggleButton = ({ isSidebarOpen, onToggle, className }: SidebarToggleButtonProps) => {
  const theme = useTheme();

  return (
    <IconButton
      color="inherit"
      aria-label="toggle sidebar"
      onClick={onToggle}
      edge="start"
      className={className}
      sx={{
        mr: 2,
        transition: theme.transitions.create(['transform', 'background-color'], {
          duration: theme.transitions.duration.short
        }),
        '&:hover': {
          backgroundColor: 'action.hover',
          transform: 'scale(1.1)'
        },
        '&:active': {
          transform: 'scale(0.95)'
        },
        transform: isSidebarOpen ? 'rotate(180deg)' : 'rotate(0deg)'
      }}
    >
      {isSidebarOpen ? <MenuOpenIcon /> : <MenuIcon />}
    </IconButton>
  );
};

export default SidebarToggleButton;
